// Global week utilities for synchronized weekly resets

export function getGlobalWeekStart(date: Date = new Date()): Date {
  // Get Monday of the current week (global boundary for all users)
  const d = new Date(date);
  const day = d.getDay(); // 0 = Sunday, 1 = Monday, etc.
  const diff = d.getDate() - day + (day === 0 ? -6 : 1); // Monday is 1 day forward, but if Sunday, go back 6 days
  const monday = new Date(d.setDate(diff));
  monday.setHours(0, 0, 0, 0);
  return monday;
}

export function isNewGlobalWeek(lastWeekStart: Date, currentDate: Date = new Date()): boolean {
  const currentGlobalWeekStart = getGlobalWeekStart(currentDate);
  const lastWeekStartTime = new Date(lastWeekStart);
  lastWeekStartTime.setHours(0, 0, 0, 0);
  
  return currentGlobalWeekStart.getTime() !== lastWeekStartTime.getTime();
}

export function getDaysSinceGlobalWeekStart(weekStart: Date, currentDate: Date = new Date()): number {
  const currentGlobalWeekStart = getGlobalWeekStart(currentDate);
  const lastWeekStartTime = new Date(weekStart);
  lastWeekStartTime.setHours(0, 0, 0, 0);
  
  const daysDifference = Math.floor(
    (currentGlobalWeekStart.getTime() - lastWeekStartTime.getTime()) / (1000 * 60 * 60 * 24)
  );
  
  return daysDifference;
}